import React from "react";

const Trello = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.018 3H6.003c-1.062 0-2.08.398-2.83 1.106a3.77 3.77 0 0 0-.87 1.228c-.2.46-.304.951-.303 1.448v22.663c0 1.002.422 1.963 1.172 2.67a4.127 4.127 0 0 0 2.83 1.107h24.016a4.125 4.125 0 0 0 2.817-1.113A3.672 3.672 0 0 0 34 29.445V6.787c0-.999-.419-1.957-1.165-2.664a4.125 4.125 0 0 0-2.817-1.113V3Zm-14.09 22.893c-.006.477-.21.933-.57 1.269a1.98 1.98 0 0 1-1.35.524H8.095a1.982 1.982 0 0 1-1.357-.52 1.764 1.764 0 0 1-.573-1.273V8.753c0-.24.049-.477.146-.698.097-.221.239-.422.418-.59.18-.17.393-.303.627-.394a2.02 2.02 0 0 1 .74-.136h5.912c.509 0 .997.191 1.357.531s.563.8.563 1.281v17.146ZM29.86 18.34c0 .48-.202.941-.562 1.281-.36.34-.848.53-1.358.53h-5.927c-.51 0-.998-.19-1.358-.53-.36-.34-.562-.8-.562-1.281V8.752c-.001-.238.048-.474.144-.695.097-.22.238-.42.416-.59a1.93 1.93 0 0 1 .624-.393 2.02 2.02 0 0 1 .736-.139h5.927c.51 0 .998.191 1.358.531.36.34.562.8.562 1.281v9.592Z"
            fill="url(#trelloa)"
        />
        <defs>
            <linearGradient
                id="trelloa"
                x1={18.01}
                y1={33.227}
                x2={18.01}
                y2={3.005}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.18} stopColor="#0052CC" />
                <stop offset={1} stopColor="#2684FF" />
            </linearGradient>
        </defs>
    </svg>
);

export default Trello;
